import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = () => (
    <Svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <Path d="M4 4L12 12" stroke={ds.colorValue.icon.warning} strokeWidth={1.75} />
    </Svg>
);

export default SvgComponent;
